// extracted by mini-css-extract-plugin
export default {"container":"dr-z","brandName":"er-z","productName":"fr-z","productNamePdpEnhancements":"gr-z","breakLongProductName":"hr-z"};